
export default (to, from, next) => {
  
    if ( obj_user.usuarioLogado() ){
           next();
    }else{
  
          next('/login');
    }
  
  }